<template>
	<div>
		<Header></Header>
		<!-- logo -->
		<div class="search">
			<div class="w search-box d-flex align-items-center">
				<div class="logo d-flex align-items-center">
					<router-link to="/"><img class="img-default logo-img" :src="common_info.store.logo" alt /></router-link>
					<div class="shopconsed">结算</div>
				</div>
				<div class="search-c d-flex align-items-center">
					<div class="search-item search-item-active d-flex align-items-center">
						<div class="search-num search-num-active d-flex align-items-center justify-content-center">1</div>我的购物车
					</div>
					<div class="search-line search-line-active"></div>
					<div class="search-item search-item-active d-flex align-items-center">
						<div class="search-num search-num-active d-flex align-items-center justify-content-center">2</div>确认订单
					</div>
					<div class="search-line"></div>
					<div class="search-item d-flex align-items-center">
						<div class="search-num d-flex align-items-center justify-content-center">3</div>付款
					</div>
					<div class="search-line"></div>
					<div class="search-item d-flex align-items-center">
						<div class="search-num d-flex align-items-center justify-content-center">4</div>确认收货
					</div>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="w">
				<!-- 地址 -->
				<div class="address">
					<div class="address-top d-flex align-items-center">收货信息</div>
					<div class="address-list d-flex flex-wrap">
						<div class="address-item d-flex flex-direction-column justify-content-between" v-for="(item,index) in address_list"
						 :key="index" :class="{address_active:address_id == item.id}" @click="selectAddress(item.id)">
							<div class="item-top d-flex align-items-center">
								<div class="top-city flex_1" :title="item.province+item.city+item.district">{{item.province+item.city+item.district}}</div>
								<div class="top-name">({{item.name}})</div>
								<div class="top-btn d-flex align-items-center justify-content-center" v-show="item.is_default == 1">默认</div>
							</div>
							<div class="address-conter">{{item.detail}} {{item.mobile}}</div>
							<div class="address-btn d-flex align-items-center">
								<div class="delete" @click.stop="deleteAddress(index)">删除</div>
								<div class="amend" @click.stop="changeAddress(index)">修改</div>
								<div class="default" @click.stop="setUpDefault(index)">设为默认</div>
							</div>
						</div>
						<div class="address-add d-flex align-items-center flex-direction-column justify-content-center" @click="addAddress()">
							<div class="add-img">
								<img class="img-default" src="../../assets/images/adddress_add.png" alt />
							</div>
							<div class="add-title">添加新地址</div>
						</div>
					</div>
				</div>
				<!-- 支付方式 -->
				<div class="pay">
					<div class="pay-title d-flex align-items-center">支付方式</div>
					<div class="pay-list d-flex flex-wrap">
						<template v-for="(payitem, payindex) in data.pay_type_list">
							<div class="pay-item d-flex align-items-center justify-content-center" v-if="payitem.payment == 0 || payitem.payment == 1|| payitem.payment == 4" :data-index="payindex" @click="checkPayType" :class="{pay_active:payitem.checked}">
								<div class="pay-img">
									<img class="img-default" :src="payitem.icon" alt />
								</div>
								<div class="pay-name">{{payitem.name}}</div>
								<div class="pay-select" v-show="payitem.checked">
									<img class="img-default" src="../../assets/images/brand.png" alt />
								</div>
							</div>
						</template>
					</div>
				</div>
				<!-- 商品信息 -->
				<div class="submitshop">
					<div class="shop-name d-flex align-items-center">商品信息</div>
					<div class="shop-title d-flex align-items-center">
						<div class="shop-title-item" style="width:35%">商品信息</div>
						<div class="shop-title-item d-flex justify-content-center" style="width:14%">规格</div>
						<div class="shop-title-item d-flex justify-content-center" style="width:24%">单价（元）</div>
						<div class="shop-title-item d-flex justify-content-center" style="width:12%">数量</div>
						<div class="shop-title-item d-flex justify-content-end" style="width:15%">小计（元）</div>
					</div>
					<div class="shop-store">
						<div class="shore-name d-flex align-items-center">平台自营</div>
						<div class="store-box">
							<!-- 普通商品 -->
							<div class="shop-item d-flex align-items-center">
								<div class="shop-details d-flex align-items-center" style="width:35%">
									<div class="shop-img">
										<img class="img-default" :src="goods.cover_pic" alt v-show="goods.cover_pic" />
										<img class="img-default" src="../../assets/images/not_img.png" alt v-show="!goods.cover_pic" />
									</div>
									<div class="shop-names">{{goods.name}}</div>
								</div>
								<div class="shop-size d-flex justify-content-center" style="width:14%">
									<div class="shop-size-box">
										<div v-for="(itemAttr,indexAttr) in goods.attr" :key="indexAttr">{{itemAttr.attr_name}}</div>
									</div>
								</div>
								<div class="shop-unpic d-flex justify-content-center" style="width:24%">
									<div class="shop-size-box">
										<div>{{goods.attr_integral}}积分</div>
										<div v-if="goods.attr_price > 0">¥ {{goods.attr_price}}</div>
									</div>
								</div>
								<div class="shop-num d-flex justify-content-center" style="width:12%">{{goods.num}}</div>
								<div class="shop-subtotal d-flex justify-content-end" style="width:15%">
									<div class="shop-size-box center">
										<div>{{goods.attr_integral}}积分</div>
										<div v-if="goods.attr_price > 0">¥ {{goods.attr_price}}</div>
									</div>
								</div>
							</div>
							<div class="shop-rest d-flex flex-wrap">
								<div class="rest-top">
									<!-- 配送方式 -->
									<div class="send">
										<div class="send-title d-flex align-items-start">配送方式</div>
										<div class="send-list d-flex">
											<div class="send-item d-flex align-items-center justify-content-center send_active">
												<div>快递配送</div>
												<div class="send-select">
													<img class="img-default" src="../../assets/images/brand.png" alt />
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="rest-top">
									<div class="leave">
										<div class="leave-title d-flex align-items-start">给卖家留言：</div>
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="content"></el-input>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 结算信息 -->
				<div class="close">
					<div class="close-title">结算信息</div>
					<div class="close-box">
						<!-- 总计 -->
						<div class="aggregate d-flex justify-content-end">
							<div class="aggregate-l d-flex flex-direction-column align-items-end">
								<div class="aggregate-l-item">
									<span>1</span>件商品 总计：
								</div>
								<div class="aggregate-l-item">运费：</div>
							</div>
							<div class="aggregate-r">
								<div class="aggregate-r-item d-flex">
									<div>{{goods.attr_integral}}积分</div>
									<template v-if="goods.attr_price > 0">
										<span>+</span>
										<div>¥ {{goods.attr_price}}</div>
									</template>
								</div>
								<div class="aggregate-r-item">¥{{data.express_price}}</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 底部提交 -->
				<div class="bottom d-flex flex-direction-column align-items-end">
					<div class="bottom-pic">
						应付金额：
						<span>¥{{all_price}}</span>
					</div>
					<template v-for="(item,index) in address_list" v-if="address_id == item.id">
						<div class="bottom-address">
							<span>寄送至：</span>{{item.city}} {{item.district}} {{item.detail}}
						</div>
						<div class="bottom-person">
							<span>收货人：</span>{{item.name}} {{item.mobile}}
						</div>
					</template>
					<div class="bottom-btn d-flex align-items-center justify-content-center" @click="payNow">提交订单</div>
				</div>
			</div>
		</div>
		<!-- 添加地址弹窗 -->
		<div class="address-mask">
			<el-dialog title="新增收货信息" :visible.sync="addressVisible">
				<div class="address-mask-box d-flex justify-content-center">
					<div class="address-mask-l d-flex flex-direction-column align-items-end">
						<div class="item-title">收货人：</div>
						<div class="item-title">手机：</div>
						<div class="item-title">所在地区：</div>
						<div class="item-title">详细地址：</div>
					</div>
					<div class="address-mask-r d-flex flex-direction-column">
						<el-input class="item-input" v-model="address_name" placeholder="姓名，如张航"></el-input>
						<div class="hint d-flex align-items-center">
							<template v-if="address_name_type">
								<div class="hint-img">
									<img class="img-default" src="../../assets/images/hint_icon.png" alt />
								</div>收货人名称最少2位
							</template>
						</div>
						<el-input v-model="address_mobile" placeholder="请填写正确的11位手机号码" maxlength="11"></el-input>
						<div class="hint d-flex align-items-center">
							<template v-if="address_mobile_type">
								<div class="hint-img">
									<img class="img-default" src="../../assets/images/hint_icon.png" alt />
								</div>请填写正确的手机号
							</template>
						</div>
						<el-cascader :options="district_list" :props="{value:'id',label:'name',children: 'list'}" v-model="address_province"
						 @change="provinceChange"></el-cascader>
						<div class="hint d-flex align-items-center">
							<template v-if="address_province_type">
								<div class="hint-img">
									<img class="img-default" src="../../assets/images/hint_icon.png" alt />
								</div>请选择地区
							</template>
						</div>
						<el-input v-model="address_detail" placeholder="街道、小区、楼牌号等"></el-input>
						<div class="hint d-flex align-items-center">
							<template v-if="address_detail_type">
								<div class="hint-img">
									<img class="img-default" src="../../assets/images/hint_icon.png" alt />
								</div>请填写详细地址
							</template>
						</div>
						<div class="default d-flex align-items-center" @click="change_default">
							<div class="default-img">
								<img class="img-default" src="../../assets/images/select_checked.png" alt v-show="address_is_default" />
								<img class="img-default" src="../../assets/images/select_unchecked.png" alt v-show="!address_is_default" />
							</div>设为默认收货地址
						</div>
						<div class="address-btn d-flex align-items-center justify-content-center" @click="preserveAddress()">保存并使用</div>
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- 支付弹层 -->
		<div class="ttshop_pay">
			<el-dialog title="" :visible.sync="pay_cont_type" :before-close="payContTypeChange">
				<div class="pay-title d-flex align-items-center justify-content-center">微信支付￥{{goods.attr_price}}</div>
				<div class="pay-qrcode d-flex align-items-center justify-content-center">
					<div id="qrcode" ref="qrcode"></div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import QRCode from "qrcodejs2";
	import "./integral.css";
	let Base64 = require("js-base64").Base64;
	export default {
		components: {
			Header,
		},
		data() {
			return {
				common_info: {
					store: {}
				},
				addressVisible: false, // 地址弹框
				address_id: '', // 选中地址id
				address_list: [], // 地址列表
				address_name: '', // 地址-用户名
				address_name_type: false,
				address_mobile: '', // 地址-手机号
				address_mobile_type: false,
				address_province: [], // 地址-省市区
				address_province_type: false,
				address_detail: '', // 地址-详细地址
				address_detail_type: false,
				address_is_default: 0, // 地址-是否设为默认地址
				district_list: [], // 地址省市区列表
				need_save_address_id: '', // 需要修改的地址id
				
				payment_type: -1,
				pay_cont_type: false, //支付二维码弹层
				order_status_query: '', //查询订单状态计时器
				loading: '',
				store: {
					store: {}
				}, //商城配置，用户信息，热搜
				goods_info: this.$store.state.submit_order_rarams,
				data: {}, //所有数据
				goods: {}, //商品信息
				content: '', //留言
				all_price: "",//应付总金额
			};
		},
		created() {
			let that = this;
			if (sessionStorage.getItem('alipay_type')) {
				that.$confirm('订单已提交,请到订单中心查看', '温馨提示', {
					confirmButtonText: '查看订单',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					that.$router.replace({
						path: '/integral_order_list',
						query: {}
					})
				}).catch(() => {
					that.$router.replace({
						path: '/integral_order_list',
						query: {}
					})
				});
			}
			this.getData();
			this.getAddressList();
			this.getDistrict();
			this.common.getCommonInfo(this);
		},
		methods: {
			// 获取数据
			getData() {
				let params = {
					goods_info: this.goods_info
				};
				if (this.address_id) {
					params.address_id = this.address_id;
				}
				this.$api.integralPrew(params).then(res => {
					console.log(res)
					if(res.code == 0){
						for (let i in res.data.pay_type_list) {
							res.data.pay_type_list[i].checked = false;
							// 默认支付方式
							if (res.data.pay_type_list[i].payment == 0) {
								res.data.pay_type_list[i].checked = true;
								this.payment_type = res.data.pay_type_list[i].payment;
							}
						}
						this.data = res.data;
						this.goods = res.data.goods;
						this.all_price = (Number(res.data.total_price) + Number(res.data.express_price)).toFixed(2);
					}
				}).catch(err => {
					this.common.message(this, err, function() {
						setTimeout(() => {
							this.$router.go(-1);
						}, 800)
					});
				});
			},
			// 选择支付方式
			checkPayType(e) {
				let index = e.currentTarget.dataset.index;
				let data = this.data;
				for (let i in this.data.pay_type_list) {
					this.$set(this.data.pay_type_list[i],"checked",false)
				}
				this.data.pay_type_list[index].checked = true;
				this.payment_type = this.data.pay_type_list[index].payment;
			},
			// 提交订单
			payNow() {
				if (!this.address_id) {
					this.$message({
						showClose: true,
						message: '请添加收货地址',
						type: 'warning',
						offset: 200,
						duration: 1000
					});
					return false;
				}
				
				if (this.payment_type == -1) {
					this.$message({
						showClose: true,
						message: '请选择支付方式',
						type: 'warning',
						offset: 200,
						duration: 1000
					});
					return false;
				}
				let params = {
					address_id: this.address_id,
					offline: 1,
					content: this.content,
					goods_info: this.goods_info,
					express_price: this.data.express_price,
					attr: JSON.stringify(this.goods.attr)
				}
				if(this.payment_type == 0||this.payment_type == 4){
					params.pay_type = 'ALIPAY';
					let payurl = window.location.href;
					let payurls = payurl.split("#")[0] + '#/integral_order_list';
					// let payurls = "http://demo.oeob.net/#/integral_order_list";
					params.return_url = payurls;
				}else if (this.payment_type == 1){
					params.pay_type = 'WECHAT_PAY'
				}
				// console.log(params);
				// return false;
				this.loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.3)'
				});
				this.$api.integarlPay(params).then(res => {
					if (res.code == 0) {
						this.loading.close();
						if (res.type == 2) {
							console.log(this.payment_type)
							if (this.payment_type == 0||this.payment_type == 4) { //支付宝
								window.sessionStorage.setItem('alipay_type', true);
								const div = document.createElement('div');
								div.innerHTML = res.data;
								document.body.appendChild(div);
								document.forms[0].submit();
							} else if(this.payment_type == 1) { //微信
								this.pay_cont_type = true;
								this.order_status_query = setInterval(() => {
									this.orderStatus(res.res.order_no);
								}, 5000);
								let url = Base64.decode(res.res.code_url);
								setTimeout(()=>{
									this.qrcodeScan(url);
								},100)
							}
						} else {
							this.$message({
								showClose: true,
								message: '兑换成功',
								type: 'success',
								offset: 200,
								duration: 1000
							});
							setTimeout(() => {
								this.$router.replace({
									path: '/integral_order_list',
									query: {}
								})
							}, 800)
						}
					}
				}).catch(error => {
					this.loading.close();
					this.common.message(this,error);
				});
			},
			qrcodeScan(url) {
				this.$refs.qrcode.innerHTML = "";
				//生成二维码
				let qrcode = new QRCode("qrcode", {
					width: 150, // 二维码宽度
					height: 150, // 二维码高度
					text: url,
				});
			},
			// 支付二维码关闭
			payContTypeChange() {
				let that = this;
				that.$confirm('是否取消支付', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					that.pay_cont_type = false;
					clearInterval(that.order_status_query);
					that.$router.replace({
						path: '/integral_order_list',
						query: {}
					})
				}).catch(() => {
					// console.log('取消')
				});
			},
			//订单状态
			orderStatus(order) {
				let that = this;
				let params = {
					order_no: "IN_" + order,
				}
				this.$api.orderStatus(params).then((res) => {
					if (res.code == 0) {
						clearInterval(that.order_status_query);
						that.$message({
							type: "success",
							message: '订单支付成功',
							showClose: true,
							offset: 200,
							duration: 1000,
						});
						setTimeout(() => {
							that.$router.replace({
								path: '/integral_order_list',
								query: {}
							})
						}, 800)
						that.pay_cont_type = false;
					}
				}).catch((err) => {
					console.log(err)
				});
			},
			// 获取地址列表
			getAddressList() {
				let that = this;
				this.$api.addressList().then(res => {
					if (res.code == 0) {
						let list = res.data.list;
						that.checkedAddress(list);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			// 地址默认选中
			checkedAddress(list) {
				let type = false;
				let that = this;
				if (list && list.length) {
					for (let i in list) {
						if (list[i].is_default == 1) {
							that.address_id = list[i].id;
							type = true;
						}
					}
					if (!type) {
						that.address_id = list[0].id;
					}
					that.address_list = list;
				} else {
					that.address_id = '';
				}
			},
			// 获取省市区
			getDistrict() {
				let that = this;
				this.$api.district().then(res => {
					if (res.code == 0) {
						that.district_list = res.data;
					}
				}).catch(err => {
					console.log(err);
				});
			},
			// 新增收货地址
			addAddress() {
				this.addressVisible = true;
				this.address_name = "";
				this.address_mobile = "";
				this.address_province = [];
				this.address_detail = "";
				this.address_is_default = 0;
			},
			// 保存地址
			preserveAddress() {
				let that = this;
				let address_name = this.address_name.trim();
				let address_mobile = this.address_mobile.trim();
				let address_province = this.address_province;
				let address_detail = this.address_detail.trim();
				this.address_name_type = false;
				this.address_mobile_type = false;
				this.address_province_type = false;
				this.address_detail_type = false;
				if (address_name.length < 2) {
					this.address_name_type = true;
					return false;
				} else if (!(/^1[3456789]\d{9}$/.test(address_mobile))) {
					this.address_mobile_type = true;
					return false;
				} else if (!address_province.length) {
					this.address_province_type = true;
					return false;
				} else if (!address_detail) {
					this.address_detail_type = true;
					return false;
				}
				let params = {
					name: address_name,
					mobile: address_mobile,
					detail: address_detail,
					lng: '0',
					lat: '0',
					province_id: address_province[0],
					city_id: address_province[1],
					district_id: address_province[2],
					is_default: this.address_is_default
				};
				if (this.need_save_address_id) {
					params.address_id = this.need_save_address_id;
				}
				this.$api.addressSave(params).then(res => {
					if (res.code == 0) {
						if (that.need_save_address_id) {
							that.need_save_address_id = '';
							that.$message({
								showClose: true,
								message: '修改成功',
								type: 'success',
								offset: 200,
								duration: 1000
							});
						} else {
							that.$message({
								showClose: true,
								message: '添加成功',
								type: 'success',
								offset: 200,
								duration: 1000
							});
						}
						that.getAddressList();
						that.addressVisible = false;
						that.address_name = '';
						that.address_mobile = '';
						that.address_province = [];
						that.address_detail = '';
						that.address_is_default = 0;
					}
				}).catch(err => {
					console.log(err);
				});
			},
			// 修改地址
			changeAddress(index) {
				let that = this;
				let address = this.address_list[index];
				this.address_name = address.name;
				this.address_mobile = address.mobile;
				this.address_province = [Number(address.province_id), Number(address.city_id), Number(address.district_id)];
				this.address_detail = address.detail;
				this.address_is_default = Number(address.is_default);
				this.need_save_address_id = address.id;
				this.addressVisible = true;
			},
			// 设为默认
			setUpDefault(index) {
				let that = this;
				let is_default = this.address_list[index].is_default;
				let params = {
					address_id: this.address_list[index].id
				}
				if (is_default != 1) {
					this.$api.addressDefault(params).then(res => {
						if (res.code == 0) {
							that.getAddressList();
						}
					}).catch(err => {
						console.log(err);
					});
				}
			},
			// 删除地址
			deleteAddress(index) {
				let that = this;
				let params = {
					address_id: this.address_list[index].id
				}
				this.$confirm('确认删除当前地址吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false,
				}).then(() => {
					that.$api.addressDelete(params).then(res => {
						if (res.code == 0) {
							that.address_list.splice(index, 1);
							that.$message({
								showClose: true,
								message: '删除成功',
								type: 'success',
								offset: 200,
								duration: 1000
							});
							let list = that.address_list;
							that.checkedAddress(list);
						}
					}).catch(error => {
						console.log(error);
					});
				}).catch(() => {});
			},
			// 选择省市区
			provinceChange(value) {
				// console.log(value);
			},
			change_default() {
				this.address_is_default = this.address_is_default == 0 ? 1 : 0;
			},
			// 地址选择
			selectAddress(id) {
				this.address_id = id;
				this.getData();
			}
		},
	};
</script>
<style lang="scss" scoped>
	.content {
		padding-bottom: 72px;
	}

	.pay_active {
		border-color: #ff0e25 !important;
	}

	.address_active {
		background-image: url(../../assets/images/address_yes.png) !important;

		.top-city {
			color: #333333 !important;
		}

		.top-name {
			color: #333333 !important;
		}
	}

	// 发票选择样式
	.invoice_active {
		border-color: #ff0e25 !important;
		background: #fafafa !important;
	}

	// 配送方式选择样式
	.send_active {
		border-color: #ff0e25 !important;

		div {
			color: #ff0e25 !important;
		}
	}

	//优惠券选择样式
	.coupon_active {
		border-top: 2px solid #ff3259 !important;
		border-bottom: 0 !important;
	}

	// logo
	.search {
		height: 112px;
		background-color: #fff;
		width: 100%;
		border-bottom: 1px solid #ebebeb;

		.search-box {
			height: 112px;

			.logo {
				a {
					display: block;
					width: 187px;
					height: 55px;

					.logo-img {
						width: auto;
						height: auto;
						object-fit: fill;
						display: block;
						margin: 0 auto;
						max-width: 100%;
						max-height: 100%;
					}
				}

				.logo-line {
					width: 1px;
					height: 55px;
					background: #ebebeb;
					margin-left: 24px;
					margin-right: 20px;
				}

				.shopconsed {
					width: 140px;
					font-size: 20px;
					color: #666666;
					margin-left: 18px;
				}
			}

			.search-c {
				margin-left: auto;

				.search-item {
					color: #999999;

					.search-num {
						width: 24px;
						height: 24px;
						background: #ebebeb;
						border-radius: 24px;
						color: #999999;
						font-size: 14px;
						margin-right: 4px;
					}

					.search-num-active {
						color: #fff;
						background: #ff9010;
					}
				}

				.search-item-active {
					color: #ff9010;
				}

				.search-line {
					width: 60px;
					height: 2px;
					background: #ebebeb;
					margin: 0 8px;
				}

				.search-line-active {
					background: #ff9010;
				}
			}
		}
	}

	// 地址
	.address {
		border-bottom: 1px solid #e6e6e6;

		.address-top {
			height: 59px;
			font-size: 16px;
		}

		.address-list {
			.address-item {
				cursor: pointer;
				width: 274px;
				height: 126px;
				background-image: url(../../assets/images/address_no.png);
				background-repeat: no-repeat;
				padding: 19px 16px;
				box-sizing: border-box;
				margin-right: 30px;
				margin-bottom: 32px;

				&:nth-child(4n) {
					margin-right: 0;
				}

				.item-top {
					.top-city {
						font-size: 16px;
						font-weight: 600;
						color: #999999;
						margin-right: 4px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.top-name {
						color: #666666;
					}

					.top-btn {
						width: 40px;
						height: 20px;
						background: #ff9010;
						border-radius: 2px;
						color: #fff;
						margin-left: auto;
					}
				}

				.address-conter {
					width: 242px;
					height: 36px;
					font-size: 12px;
					color: #666666;
					line-height: 18px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
				}

				.address-btn {
					.delete {
						color: #999999;
					}

					.amend {
						color: #0e9cff;
						margin-left: auto;
					}

					.default {
						color: #0e9cff;
						margin-left: 16px;
					}
				}
			}

			.address-add {
				cursor: pointer;
				width: 274px;
				height: 126px;
				background-image: url(../../assets/images/address_no.png);
				background-repeat: no-repeat;
				margin-bottom: 32px;

				.add-img {
					height: 34px;
					width: 34px;
				}

				.add-title {
					color: #999999;
					line-height: 12px;
					margin-top: 8px;
				}
			}
		}
	}

	// 支付方式
	.pay {
		.pay-title {
			height: 72px;
			font-size: 16px;
		}

		.pay-list {
			.pay-item {
				position: relative;
				width: 158px;
				height: 40px;
				background: #ffffff;
				border-radius: 2px;
				border: 1px solid #ebebeb;
				margin-right: 20px;
				margin-bottom: 20px;
				cursor: pointer;

				// &:hover{
				//   border-color: #FF0E25;
				// }
				.pay-img {
					height: 24px;
					width: 27px;
					margin-right: 8px;
				}

				.pay-name {
					color: #666666;
					font-size: 16px;
				}

				.pay-select {
					height: 12px;
					width: 12px;
					position: absolute;
					right: 0;
					bottom: 0;
				}
			}
		}
	}

	// 商品信息
	.submitshop {
		.shop-name {
			height: 40px;
			font-size: 16px;
		}

		.shop-title {
			height: 40px;
			background-color: #fafafa;
			padding: 0 24px;
			box-sizing: border-box;
		}

		.shop-store {
			.shore-name {
				padding: 0 24px;
				box-sizing: border-box;
				height: 48px;
				font-weight: 600;

				.shore-img {
					height: 12px;
					width: 12px;
					margin-left: 4px;
				}
			}

			.store-box {
				background: #ffffff;
				border: 1px solid #ebebeb;
				padding: 0 24px;
				box-sizing: border-box;

				.shop-item {
					padding: 20px 0;
					box-sizing: border-box;
					border-bottom: 1px solid #e6e6e6;

					.shop-details {
						.shop-img {
							height: 60px;
							width: 60px;
						}

						.shop-names {
							width: 230px;
							height: 36px;
							color: #666666;
							line-height: 18px;
							margin-left: 16px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
						}
					}

					.shop-size {
						.shop-size-box {
							width: 100%;

							div {
								color: #666666;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
						}
					}

					.shop-unpic {
						text-align: center;
						color: #666666;
					}

					.shop-num {
						color: #666666;
					}

					.shop-subtotal {
						text-align: center;
						font-weight: bold;
					}
				}

				.setmeal-box {
					.setmeal-title {
						margin-top: 20px;

						.setmeal-unpic {
							color: #666666;
						}

						.setmeal-num {
							color: #666666;
						}

						.setmeal-subtotal {
							font-weight: bold;
						}
					}

					.setmeal-list {
						.setmeal-item {
							padding: 20px 0;
							box-sizing: border-box;
							border-bottom: 1px dashed #e6e6e6;

							&:last-child {
								border-bottom: 1px solid #e6e6e6;
							}

							.shop-details {
								.shop-img {
									height: 60px;
									width: 60px;
								}

								.shop-names {
									width: 230px;
									height: 36px;
									color: #666666;
									line-height: 18px;
									margin-left: 16px;
									overflow: hidden;
								}
							}

							.shop-size {
								.shop-size-box {
									div {
										color: #666666;
									}
								}
							}

							.shop-unpic {
								color: #666666;
							}

							.shop-num {
								color: #666666;
							}

							.shop-subtotal {
								font-weight: bold;
							}
						}
					}
				}

				.shop-rest {
					.rest-top {
						width: 50%;
						border-bottom: 1px dashed #e6e6e6;
						box-sizing: border-box;

						&:nth-child(2n) {
							border-left: 1px dashed #e6e6e6;
						}

						&:nth-child(3) {
							border-bottom: 0;
						}

						&:nth-child(4) {
							border-bottom: 0;
						}

						// 发票
						.invoice {
							padding: 30px 30px 24px 20px;
							box-sizing: border-box;

							.invoice-title {
								height: 32px;
								line-height: 12px;
								margin-left: -20px;
								cursor: pointer;

								.invoice-select {
									height: 12px;
									width: 12px;
									margin-right: 8px;
								}
							}

							.invoice-content {
								// margin: 0 30px 20px 20px;
								background-color: #fafafa;
								padding: 16px;
								box-sizing: border-box;

								.tab-list {
									.tab-item {
										height: 32px;
										min-width: 82px;
										padding: 0 12px;
										box-sizing: border-box;
										background: #ffffff;
										border-radius: 2px;
										border: 1px solid #ebebeb;
										margin-right: 8px;
										position: relative;
										box-sizing: border-box;
										cursor: pointer;
										margin-bottom: 10px;

										.tab-img {
											width: 18px;
											height: 18px;
											background-color: #fff0f1;
											color: #ff3259;
											margin-right: 4px;
										}

										.tab-select {
											height: 12px;
											width: 12px;
											position: absolute;
											right: 0;
											bottom: 0;
										}
									}
								}
							}
						}

						//配送
						.send {
							padding: 30px 0 24px 30px;
							box-sizing: border-box;

							.send-title {
								height: 32px;
								line-height: 12px;
								// margin-left: -20px;
							}

							.send-list {
								.send-item {
									height: 32px;
									width: 140px;
									box-sizing: border-box;
									background: #ffffff;
									border-radius: 2px;
									border: 1px solid #ebebeb;
									margin-right: 8px;
									position: relative;
									box-sizing: border-box;
									cursor: pointer;

									.send-select {
										height: 12px;
										width: 12px;
										position: absolute;
										right: 0;
										bottom: 0;
									}
								}
							}

							.send-box {
								padding: 16px;
								box-sizing: border-box;
								background: #fafafa;
								margin-top: 16px;

								.send-box-item {
									+.send-box-item {
										margin-top: 16px;
									}

									span {
										margin-left: 20px;
										color: #0e9cff;
										cursor: pointer;
									}
								}
							}

							.send-pic {
								margin-top: 20px;
							}
						}

						// 优惠券
						.coupon {
							padding: 30px 30px 24px 20px;
							box-sizing: border-box;

							.coupon-title {
								height: 32px;
								line-height: 12px;
								margin-left: -20px;
								cursor: pointer;

								.coupon-select {
									height: 12px;
									width: 12px;
									margin-right: 8px;
								}
							}

							.coupon-box {
								position: relative;

								.coupon-tab {
									position: relative;
									background: #fff;
									z-index: 10;
									height: 32px;
									width: 216px;

									.tab-item {
										width: 108px;
										border: 1px solid #ebebeb;
										cursor: pointer;

										&:last-child {
											border-left: 0;
										}
									}
								}

								.coupon-list {
									// position: relative;
									margin-top: -1px;
									width: 522px;
									background: #ffffff;
									border: 1px solid #ebebeb;
									padding: 16px 0;
									box-sizing: border-box;
									max-height: 188px;
									overflow-y: scroll;

									.list-item {
										padding: 10px 15px;
										box-sizing: border-box;
										background: #fafafa;
										cursor: pointer;

										.item-pic {
											font-size: 20px;
											color: #ff3259;
											font-weight: bold;

											span {
												font-size: 12px;
												color: #ff3259;
												font-weight: bold;
											}
										}

										+.list-item {
											margin-top: 8px;
										}
									}
								}
							}
						}

						.leave {
							padding: 30px 0 24px 30px;
							box-sizing: border-box;

							.leave-title {
								height: 32px;
								line-height: 12px;
							}
						}
					}
				}
			}
		}
	}

	// 结算信息
	.close {
		.close-title {
			height: 64px;
			padding-top: 32px;
			box-sizing: border-box;
			font-size: 16px;
		}

		.close-box {
			border: 1px solid #ebebeb;
			padding: 24px 0;
			box-sizing: border-box;

			// 积分
			.integral {
				padding-left: 24px;
				box-sizing: border-box;

				.integral-title {
					margin-left: 8px;

					span {
						color: #ff0e25;
					}
				}
			}

			//消费卡
			.expense {
				margin-bottom: 20px;

				.expense-top {
					padding-left: 24px;
					box-sizing: border-box;
					margin-top: 20px;

					.expense-img {
						height: 12px;
						width: 12px;
					}

					.expense-title {
						margin-left: 8px;
					}
				}

				.expense-box {
					position: relative;
					margin-top: 20px;

					.expense-tab {
						position: relative;
						z-index: 10;
						height: 32px;

						// width: 216px;
						.tab-item {
							padding: 0 24px;
							border: 1px solid #ebebeb;
							background: #fff;
							cursor: pointer;
							border-left: 0;
							box-sizing: border-box;
						}
					}

					.expense-list {
						position: relative;
						margin-top: -1px;
						background: #ffffff;
						border: 1px solid #ebebeb;
						border-left: 0;
						border-right: 0;
						padding: 16px 0;
						box-sizing: border-box;

						.list-item {
							padding: 10px 15px;
							box-sizing: border-box;
							background: #fafafa;
							padding-right: 250px;

							.item-pic {
								font-size: 20px;
								color: #ff3259;
								font-weight: bold;

								span {
									font-size: 12px;
									color: #ff3259;
									font-weight: bold;
								}
							}

							+.list-item {
								margin-top: 8px;
							}
						}
					}
				}
			}

			// 总计
			.aggregate {
				margin-top: 32px;
				padding-right: 36px;
				box-sizing: border-box;

				.aggregate-l {
					margin-right: 64px;

					.aggregate-l-item {
						+.aggregate-l-item {
							margin-top: 4px;
						}

						span {
							color: #ff0e25;
						}
					}
				}

				.aggregate-r {
					.aggregate-r-item {
						+.aggregate-r-item {
							margin-top: 4px;
						}
					}
				}
			}
		}
	}

	// 底部提交
	.bottom {
		margin-top: 32px;

		.bottom-pic {
			color: #666666;

			span {
				color: #ff4300;
				font-size: 22px;
			}
		}

		.bottom-address {
			margin-top: 12px;

			span {
				color: #666666;
			}
		}

		.bottom-person {
			span {
				color: #666666;
			}
		}

		.bottom-btn {
			width: 104px;
			height: 40px;
			background: #ff0e25;
			border-radius: 2px;
			color: #fff;
			font-size: 16px;
			margin-top: 12px;
			cursor: pointer;
		}
	}

	//添加地址弹窗
	.address-mask {
		.address-mask-l {
			width: 60px;
			margin-right: 16px;

			.item-title {
				height: 28px;
				line-height: 28px;
				margin-bottom: 20px;
			}
		}

		.address-mask-r {
			.hint {
				height: 20px;
				color: #ff8500;

				.hint-img {
					height: 12px;
					width: 12px;
					margin-right: 8px;
				}
			}

			.default {
				.default-img {
					height: 12px;
					width: 12px;
					margin-right: 4px;
				}
			}

			.address-btn {
				width: 108px;
				height: 32px;
				background: #ff0e25;
				border-radius: 2px;
				color: #fff;
				margin-top: 38px;
			}
		}
	}

	input::-webkit-input-placeholder {
		color: #999999;
	}

	.address-mask-box {
		.default {
			cursor: pointer;
		}

		.address-btn {
			cursor: pointer;
		}
	}

	.mailbox-box {
		padding-top: 32px;
		box-sizing: border-box;
		font-size: 16px;

		.title {
			float: left;
			font-size: 16px;
			line-height: 30px;
		}

		input {
			border: 1px solid #ebebeb;
			border-radius: 2px;
			padding: 0 10px;
			font-size: 14px;
			line-height: 30px;
			width: 240px;
		}
	}

	.ttshop_pay {
		.pay-title {
			width: 100%;
			font-size: 14px;
			font-weight: bold;
			margin-bottom: 10px;
		}

		.pay-qrcode {
			width: 200px;
			height: 200px;
		}
	}
</style>
